import { useEffect } from 'react';
import urlBase64ToUint8Array from './urlBase64ToUint8Array';
import api from '../Axios.js';

const PUBLIC_VAPID_KEY = process.env.REACT_APP_PUBLIC_VAPID_KEY;

export async function subscribeUser() {
  if (!PUBLIC_VAPID_KEY) {
    console.error('Missing VAPID public key in environment variables');
    return;
  }
  
  if (!('serviceWorker' in navigator)) {
    console.error('Service workers not supported in this browser');
    return;
  }

  try {
    // Register the service worker - make sure sw.js is in your public folder
    const registration = await navigator.serviceWorker.register(`${process.env.REACT_APP_BUILD_PATH}/sw.js`);

    // Request permission for notifications
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return;
    }

    // Subscribe to push notifications
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY),
    });

    // Send subscription object to backend to save
    await api.post('/notification/save-push-notification-subscription', subscription);

    console.log('User subscribed to push notifications');
  } catch (error) {
    console.error('Failed to subscribe the user:', error);
  }
}
